import { Clues } from "./model/Clues";
import { util } from "../lib/util/util";
import { storage } from "../lib/util/storage";
import { ewent } from "../lib/reactive";
var todo = util.todo;
var ClueSpot = Clues.ClueSpot;
import { FakeLodash } from "../lib/coreutil/FakeLodash";
export class FavoriteIndex {
    constructor(methods) {
        this.methods = methods;
        this.method_favourite_changed = ewent();
        this.data = new storage.Variable("clue_favourites", () => null);
        this.normalize_data();
    }
    normalize_data() {
        if (!this.data.value)
            this.data.value = { methods: [], challenge_answers: [] };
        if (!this.data.value.methods)
            this.data.value.methods = [];
        if (!this.data.value.challenge_answers)
            this.data.value.challenge_answers = [];
        this.data.save();
    }
    getTalkId(clue) {
        todo();
    }
    setTalkId(clue, id) {
        todo();
    }
    getChallengeAnswerId(clue) {
        return this.data.value.challenge_answers.find(a => a.clue_id == clue.id)?.answer_id ?? 0;
    }
    setChallengeAnswerId(clue, answer_id) {
        const entry = this.data.value.challenge_answers.find(a => a.clue_id == clue.id);
        if (entry) {
            entry.answer_id = answer_id;
        }
        else {
            this.data.value.challenge_answers.push({ clue_id: clue.id, answer_id: answer_id });
        }
        this.data.save();
    }
    async getMethod(step, return_fallback = true) {
        const entry = this.data.value.methods.find(v => ClueSpot.Id.equals(step, v.spot));
        if (!entry && return_fallback) {
            // There is no entry at all for this clue, automatically choose one!
            // Default choice is the fastest builtin method, followed by the fastest custom method if no builtin is available
            const candidates = await this.methods.getForClue(step);
            const c1 = candidates.find(c => c.pack.type == "default" && c.method.is_default_override);
            if (c1)
                return c1;
            const c2 = FakeLodash.minBy(candidates.filter(c => c.pack.type == "default"), c => c.method.expected_time);
            if (c2)
                return c2;
            return FakeLodash.minBy(candidates, c => c.method.expected_time);
        }
        if (!entry)
            return undefined;
        if (!entry?.method)
            return null;
        return this.methods.resolve(entry.method);
    }
    setMethod(step, method) {
        this.normalize_data();
        const i = this.data.value.methods.findIndex(e => ClueSpot.Id.equals(e.spot, step));
        if (method === undefined) {
            if (i >= 0)
                this.data.value.methods.splice(i, 1);
        }
        else if (i >= 0) {
            const entry = this.data.value.methods[i];
            entry.method = method
                ? { local_pack_id: method.pack.local_id, method_id: method.method.id }
                : null;
        }
        else {
            this.data.value.methods.push({
                spot: FakeLodash.cloneDeep(step),
                method: method
                    ? { local_pack_id: method.pack.local_id, method_id: method.method.id }
                    : null
            });
        }
        this.method_favourite_changed.trigger({
            clue: step,
            new: method
        });
        this.data.save();
    }
}
